import flower from "@/assets/icons/flower.png";
import photograph from "@/assets/icons/photograph.png";
import suite from "@/assets/icons/suite.png";
import venue from "@/assets/icons/lokal_ikon_1.png";
import videocamera from "@/assets/icons/videocamera.png";
import weddingCake from "@/assets/icons/wedding-cake.png";
import weddingCard from "@/assets/icons/wedding-card.png";
import weddingDress from "@/assets/icons/wedding-dress.png";
import weddingRing from "@/assets/icons/wedding-ring.png";

/** Featured grid in nav dropdown + mobile menu (DB category display names). */
export const FEATURED_CATEGORY_ICONS: Record<string, string> = {
  Bröllopslokaler: venue,
  Bröllopskostym: suite,
  Brudklänning: weddingDress,
  Bröllopsfotograf: photograph,
  Videograf: videocamera,
  Vigselringar: weddingRing,
  Bröllopstårta: weddingCake,
  Brudbukett: flower,
  Bröllopskort: weddingCard,
};

export const FEATURED_CATEGORIES = [
  "Bröllopslokaler",
  "Bröllopskostym",
  "Brudklänning",
  "Bröllopsfotograf",
  "Videograf",
  "Vigselringar",
  "Bröllopstårta",
  "Brudbukett",
  "Bröllopskort",
] as const;

export type FeaturedCategoryName = (typeof FEATURED_CATEGORIES)[number];
